import React, { memo } from 'react';
import { HeaderSkeleton } from 'site-modules/personalized-search/components/header-content/header-skeleton/header-skeleton';
import { VerdictSkeleton } from 'site-modules/personalized-search/components/verdict/verdict-skeleton/verdict-skeleton';
import { OpinionSkeleton } from 'site-modules/personalized-search/components/opinion/opinion-skeleton/opinion-skeleton';
import { HighlightsSkeleton } from 'site-modules/personalized-search/components/higlights/highlights-skeleton/highlights-skeleton';
import { LearnMoreSkeleton } from 'site-modules/personalized-search/components/learn-more/learn-more-skeleton/learn-more-skeleton';
import { CollapsibleOverviewItemSkeleton } from 'site-modules/personalized-search/components/overview/collapsible-overview-item-skeleton/collapsible-overview-item-skeleton';
import PropTypes from 'prop-types';
import { ExtractSkeleton } from 'site-modules/personalized-search/components/extract/extract-skeleton/extract-skeleton';

export const OverviewItemSkeleton = memo(({ isMobile = false, withCollapse = false, ...restProps }) => {
  if (withCollapse) {
    return <CollapsibleOverviewItemSkeleton isMobile={isMobile} withCollapse={withCollapse} {...restProps} />;
  }

  return (
    <div className="overview-item-skeleton">
      <HeaderSkeleton withCtaSkeleton={!isMobile} />
      <VerdictSkeleton />
      <ExtractSkeleton />
      <OpinionSkeleton />
      <HighlightsSkeleton />
      <LearnMoreSkeleton />
    </div>
  );
});

OverviewItemSkeleton.displayName = 'OverviewItemSkeleton';

OverviewItemSkeleton.propTypes = {
  isMobile: PropTypes.bool,
  withCollapse: PropTypes.bool,
};
